<div class="row">
    <div class="col">
      <agm-map>
        <agm-direction  [travelMode] = 'mode'  *ngIf="dir" [origin]="dir.origin" 
        [destination]="dir.destination"s></agm-direction>
      </agm-map>
    </div>
  </div>
  <div class="row" style="margin-top:10px">
      <div #myPanel></div>
    <div class="col">
        <button class="btn btn-success btn-block"  mat-dialog-close style="margin-bottom: 1%">Cancel</button>   
      </div>
  </div>